import type { TenderOfferDraft } from './types';
import { DEFAULT_LABOR_RATE, DEFAULT_MATERIAL_MARKUP_RATE, DEFAULT_VAT_RATE } from './types';

/** Brutto (inkl. MwSt.) aus offer_draft — gleiche Logik wie TenderTotalsBar. */
export function computeTenderGrossFromDraft(
  d: TenderOfferDraft | null | undefined,
): number | null {
  if (!d?.rows?.length) return null;
  const laborRate = d.laborRate ?? DEFAULT_LABOR_RATE;
  const vatRate = d.vatRate ?? DEFAULT_VAT_RATE;
  const materialMarkupRate = d.materialMarkupRate ?? DEFAULT_MATERIAL_MARKUP_RATE;
  const rows = d.rows;
  const materialTotal = rows.reduce(
    (sum, r) => sum + (r.materialPrice || 0) * (r.internalQty || 0),
    0,
  );
  const materialWithMarkup = materialTotal * (1 + materialMarkupRate / 100);
  const totalMinutes = rows.reduce(
    (sum, r) => sum + (r.minutesPerUnit || 0) * (r.internalQty || 0),
    0,
  );
  const laborTotal = (totalMinutes / 60) * laborRate;
  const netTotal = materialWithMarkup + laborTotal;
  return netTotal * (1 + vatRate / 100);
}

export function formatTenderGrossEuro(d: TenderOfferDraft | null | undefined): string | null {
  const n = computeTenderGrossFromDraft(d);
  if (n == null) return null;
  return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(n);
}
